<template>
  <div class="c-app">
    <CWrapper>
      <TheHeader v-if="isAdmin()"/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheHeader from './TheHeader'
export default {
  name: 'TheContainer',
  components: {
    TheHeader
  },
  methods: {
    isAdmin(){
      return (localStorage.isAdmin == "1");
    }
  }
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
